// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"8":"fecd2162","132":"e6a6aaff","290":"dda9edef","444":"3fadcd45","760":"fa3be158","800":"11496487"}[chunkId] + ".css";
};